import useTasksStore from '@/common/store/pinia/tasks';
import { store } from '@/common/root';
import type {
  StoreOnActionListenerContext,
  StoreActions,
  StoreGetters,
  StoreState,
  StoreGeneric
} from 'pinia';
import useVhsTasksStore from '@/common/store/pinia/vhsTasks';

type Subscription<S extends StoreGeneric = StoreGeneric> = {
  store: S;
  actionsMap: {
    [K in keyof StoreActions<S>]?: (ctx: StoreOnActionListenerContext<S['$id'], StoreState<S>, StoreGetters<S>, StoreActions<S>>) => void;
  };
};

const subscribeToActions = <T extends readonly Subscription<any>[]>(
  subscriptions: T
): void => {
  subscriptions.forEach(({ store: piniaStore, actionsMap }: Subscription<any>) => {
    piniaStore.$onAction((ctx) => {
      actionsMap[ctx.name]?.(ctx);
    });
  });
};

export default () => {
  subscribeToActions([
    {
      store: useTasksStore(),
      actionsMap: {
        fetchItems: ({ after }) => after(
          ({ data }) => data.forEach(task => store.dispatch('notifications/REVEAL_TASK', task))
        ),
        fetchItem: ({ after }) => after(
          ({ data }) => store.dispatch('notifications/REVEAL_TASK', data)
        ),
      }
    },
    {
      store: useVhsTasksStore(),
      actionsMap: {
        fetchItems: ({ after }) => after(
          ({ data }) => data?.data?.forEach(vhsTask => store.dispatch('notifications/REVEAL_VHS_TASK', vhsTask))
        ),
        fetchItem: ({ after }) => after(
          ({ data }) => store.dispatch('notifications/REVEAL_VHS_TASK', data)
        ),
      }
    }
  ]);
};
